module.exports = __webpack_public_path__ + "static/media/pic-svg-18.80d09117.svg";